import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect as connectR } from 'react-redux';
import translate from '../translate';
import LeftSide from '../main/left-side';
import RightSide from '../main/right-side';
import Navbar from '../navigation/navbar';
import ManageEmailAddress from './manage-email';
import { Link } from 'react-router';
import TitleCard from '../main/title-card';

interface Props {
    strings: {
        cancel: string;
        sideTitle: string;
    };
}

class ManageAccountWrapper extends React.Component<Props> {
    render() {
        const getBackArrow = () => ({
            content: (
                <Link
                    to="/dashboard"
                    className="icon icon-wew-arrow-left icon-sm"
                />
            ),
            title: this.props.strings.cancel,
        });
        return (
            <Navbar nav>
                <Row>
                    <LeftSide>
                        <TitleCard
                            title={[this.props.strings.sideTitle]}
                            left={getBackArrow()}
                        />
                    </LeftSide>
                    <Col xs={6} className={'col-middle'}>
                        <ManageEmailAddress {...this.props} />
                    </Col>
                    <RightSide></RightSide>
                </Row>
            </Navbar>
        );
    }
}

export default connectR()(translate('ChangeEmailForm')(ManageAccountWrapper));
